import { createContext, ReactNode, useEffect, useState } from 'react';
import { IProduct } from '../../interfaces/IProduct';
import api from '../../Services/api';
import { toast } from 'react-toastify';
import globals from './../../Globals.json';

interface ChildrenProps {
  children: ReactNode;
}

interface InitialContextInterface {
  status: boolean;
  setStatus: React.Dispatch<React.SetStateAction<boolean>>;
  idPdv: string;
  setIdPdv: React.Dispatch<React.SetStateAction<string>>;
  image: string;
  setImage: React.Dispatch<React.SetStateAction<string>>;
  barcode: string;
  setBarcode: React.Dispatch<React.SetStateAction<string>>;
  descriptionSale: string;
  setDescriptionSale: React.Dispatch<React.SetStateAction<string>>;
  descriptionPurchase: string;
  setDescriptionPurchase: React.Dispatch<React.SetStateAction<string>>;
  descriptionTouch: string;
  setDescriptionTouch: React.Dispatch<React.SetStateAction<string>>;
  category?: number;
  setCategory: React.Dispatch<React.SetStateAction<number | undefined>>;
  vendor?: number;
  setVendor: React.Dispatch<React.SetStateAction<number | undefined>>;
  productType?: number;
  setProductType: React.Dispatch<React.SetStateAction<number | undefined>>;
  sale: string;
  setSale: React.Dispatch<React.SetStateAction<string>>;
  minSale: string;
  setMinSale: React.Dispatch<React.SetStateAction<string>>;
  coast: string;
  setCoast: React.Dispatch<React.SetStateAction<string>>;
  promotionalPrice: string;
  setPromotionalPrice: React.Dispatch<React.SetStateAction<string>>;
  markupPrice: string;
  setMarkupPrice: React.Dispatch<React.SetStateAction<string>>;
  markup: string;
  setMarkup: React.Dispatch<React.SetStateAction<string>>;
  stock_uuid: string;
  setStock_uuid: React.Dispatch<React.SetStateAction<string>>;

  unit: number;
  setUnit: React.Dispatch<React.SetStateAction<number>>;
  currentAmount: string;
  setCurrentAmount: React.Dispatch<React.SetStateAction<string>>;
  minAmount: string;
  setMinAmount: React.Dispatch<React.SetStateAction<string>>;
  localStockName: string;
  setLocalStockName: React.Dispatch<React.SetStateAction<string>>;
  localStock?: number;
  setLocalStock: React.Dispatch<React.SetStateAction<number | undefined>>;
  typeOper?: number;
  setTypeOper: React.Dispatch<React.SetStateAction<number | undefined>>;
  unitMeasureBuy?: number;
  setUnitMeasureBuy: React.Dispatch<React.SetStateAction<number | undefined>>;
  multiple: string;
  setMultiple: React.Dispatch<React.SetStateAction<string>>;
  observation?: string;
  setObservation: React.Dispatch<React.SetStateAction<string>>;
  taxProfile?: number;
  setTaxProfile: React.Dispatch<React.SetStateAction<number | undefined>>;
  stateOrigin?: number;
  setStateOrigin: React.Dispatch<React.SetStateAction<number | undefined>>;
  stateDestiny?: number;
  setStateDestiny: React.Dispatch<React.SetStateAction<number | undefined>>;
  types?: number;
  setTypes: React.Dispatch<React.SetStateAction<number | undefined>>;
  origins?: number;
  setOrigins: React.Dispatch<React.SetStateAction<number | undefined>>;
  ncm?: number;
  setNcm: React.Dispatch<React.SetStateAction<number | undefined>>;
  cest?: number;
  setCest: React.Dispatch<React.SetStateAction<number | undefined>>;
  cfop?: number;
  setCfop: React.Dispatch<React.SetStateAction<number | undefined>>;
  customer?: number;
  setCustomer: React.Dispatch<React.SetStateAction<number | undefined>>;
  icms?: number;
  setIcms: React.Dispatch<React.SetStateAction<number | undefined>>;
  ipi?: number;
  setIpi: React.Dispatch<React.SetStateAction<number | undefined>>;
  cstReasons?: number;
  setCstReasons: React.Dispatch<React.SetStateAction<number | undefined>>;
  pis?: number;
  setPis: React.Dispatch<React.SetStateAction<number | undefined>>;
  cofins?: number;
  setCofins: React.Dispatch<React.SetStateAction<number | undefined>>;

  weight: string;
  setWeight: React.Dispatch<React.SetStateAction<string>>;
  ncm_origin: string;
  setNcm_origin: React.Dispatch<React.SetStateAction<string>>;

  aliquot: string;
  setAliquotIcms: React.Dispatch<React.SetStateAction<string>>;
  mva: string;
  setMva: React.Dispatch<React.SetStateAction<string>>;
  reduction: string;
  setReduction: React.Dispatch<React.SetStateAction<string>>;
  icmsAliquotDeferral: string;
  setIcmsAliquotDeferral: React.Dispatch<React.SetStateAction<string>>;
  icmsCredit: string;
  setIcmsCredit: React.Dispatch<React.SetStateAction<string>>;
  aliquotIpi: string;
  setAliquotIpi: React.Dispatch<React.SetStateAction<string>>;
  aliquotPis: string;
  setAliquotPis: React.Dispatch<React.SetStateAction<string>>;
  aliquotCofins: string;
  setAliquotCofins: React.Dispatch<React.SetStateAction<string>>;
  xdRequestQty: boolean;
  setXdRequestQty: React.Dispatch<React.SetStateAction<boolean>>;
  xdRequestPriceWhenZero: boolean;
  setXdRequestPriceWhenZero: React.Dispatch<React.SetStateAction<boolean>>;
  xdBalanceQty: boolean;
  setXdBalanceQty: React.Dispatch<React.SetStateAction<boolean>>;
  xdOrderGrouped: boolean;
  setXdOrderGrouped: React.Dispatch<React.SetStateAction<boolean>>;
  xdBillGroup: boolean;
  setXdBillGroup: React.Dispatch<React.SetStateAction<boolean>>;
  xdAddTips: boolean;
  setXdAddTips: React.Dispatch<React.SetStateAction<boolean>>;
  xdExcludeMinimumConsumption: boolean;
  setXdExcludeMinimumConsumption: React.Dispatch<React.SetStateAction<boolean>>;
  selfService: boolean;
  setSelfService: React.Dispatch<React.SetStateAction<boolean>>;
  xdBook: boolean;
  setXdBook: React.Dispatch<React.SetStateAction<boolean>>;

  xdFollowItem: boolean;
  setXdFollowItem: React.Dispatch<React.SetStateAction<boolean>>;
  xdPrinters: string;
  setXdPrinters: React.Dispatch<React.SetStateAction<string>>;
  cleanInputs: () => void;
  handleEdit: (props: IProduct) => void;
  handleDuplicate: (props: IProduct) => void;
  handleValidete: () => boolean;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  listCode: any;
  setListCode: React.Dispatch<React.SetStateAction<any[]>>;
  categoriesList: any;
  setCategoriesComplement: React.Dispatch<React.SetStateAction<any[]>>;
  productsList: any;
  setProductsComplement: React.Dispatch<React.SetStateAction<any[]>>;

  setAssociatedComplement: React.Dispatch<React.SetStateAction<any[]>>;
  associatedComplement: any;
  productsAssociatedComplement: any;
  setProductsAssociatedComplement: React.Dispatch<React.SetStateAction<any[]>>;

  validCode: boolean;
  setValidCode: React.Dispatch<React.SetStateAction<boolean>>;
  validDescriptionSale: boolean;
  setValidDescriptionSale: React.Dispatch<React.SetStateAction<boolean>>;
  validDescriptionPurchase: boolean;
  setValidDescriptionPurchase: React.Dispatch<React.SetStateAction<boolean>>;
  validDescriptionTouch: boolean;
  setValidDescriptionTouch: React.Dispatch<React.SetStateAction<boolean>>;
  validCategory: boolean;
  setValidCategory: React.Dispatch<React.SetStateAction<boolean>>;
  validProductType: boolean;
  setValidProductType: React.Dispatch<React.SetStateAction<boolean>>;
  validSale: boolean;
  setValidSale: React.Dispatch<React.SetStateAction<boolean>>;
  validMinSale: boolean;
  setValidMinSale: React.Dispatch<React.SetStateAction<boolean>>;
  validCoast: boolean;
  setValidCoast: React.Dispatch<React.SetStateAction<boolean>>;
  validUnit: boolean;
  setValidUnit: React.Dispatch<React.SetStateAction<boolean>>;
  validNcm: boolean;
  setValidNcm: React.Dispatch<React.SetStateAction<boolean>>;

  validCfop: boolean;
  setValidCfop: React.Dispatch<React.SetStateAction<boolean>>;
  validIcms: boolean;
  setValidIcms: React.Dispatch<React.SetStateAction<boolean>>;
  validAliquot: boolean;
  setValidAliquot: React.Dispatch<React.SetStateAction<boolean>>;
  validIpi: boolean;
  setValidIpi: React.Dispatch<React.SetStateAction<boolean>>;
  validAliquotIpi: boolean;
  setValidAliquotIpi: React.Dispatch<React.SetStateAction<boolean>>;
  validPis: boolean;
  setValidPis: React.Dispatch<React.SetStateAction<boolean>>;
  validAliquotPis: boolean;
  visible_falimix: boolean;
  setVisible_falimix: React.Dispatch<React.SetStateAction<boolean>>;
  visible_autoplu: boolean;
  setVisible_autoplu: React.Dispatch<React.SetStateAction<boolean>>;
  visible_delivery: boolean;
  setVisible_delivery: React.Dispatch<React.SetStateAction<boolean>>;
  visible_xd_orders: boolean;
  setVisible_xd_orders: React.Dispatch<React.SetStateAction<boolean>>;
  visible_online: boolean;
  setVisible_online: React.Dispatch<React.SetStateAction<boolean>>;
  visible_digital_menu: boolean;
  setVisible_digital_menu: React.Dispatch<React.SetStateAction<boolean>>;
  setValidCofins: React.Dispatch<React.SetStateAction<boolean>>;
  validCofins: boolean;
  setValidAliquotPis: React.Dispatch<React.SetStateAction<boolean>>;
  validType: boolean;
  setValidType: React.Dispatch<React.SetStateAction<boolean>>;
  validOrigins: boolean;
  setValidOrigins: React.Dispatch<React.SetStateAction<boolean>>;
  validqty: boolean;
  setValidqty: React.Dispatch<React.SetStateAction<boolean>>;
  validLocalStock: boolean;
  setValidLocalStock: React.Dispatch<React.SetStateAction<boolean>>;
  validOrigem: boolean;
  setValidOrigem: React.Dispatch<React.SetStateAction<boolean>>;
  validcstReasons: boolean;
  setValidcstReasons: React.Dispatch<React.SetStateAction<boolean>>;
  loadingListCode: boolean;
  setLoadingListCode: React.Dispatch<React.SetStateAction<boolean>>;
  taxProfileManuallySelected: boolean;
  setTaxProfileManuallySelected: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ProdutoContext = createContext<InitialContextInterface>(
  {} as InitialContextInterface
);

export const ProdutoProvider = ({ children }: ChildrenProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  //Dados gerais
  const [status, setStatus] = useState<boolean>(true);
  const [image, setImage] = useState<string>('');
  const [idPdv, setIdPdv] = useState<string>('');
  const [barcode, setBarcode] = useState<string>('');
  const [ncm_origin, setNcm_origin] = useState<string>('Nacional');
  const [descriptionSale, setDescriptionSale] = useState('');
  const [descriptionPurchase, setDescriptionPurchase] = useState('');
  const [descriptionTouch, setDescriptionTouch] = useState('');
  const [category, setCategory] = useState<number | undefined>(undefined);
  const [vendor, setVendor] = useState<number | undefined>(undefined);
  const [productType, setProductType] = useState<number | undefined>(1);
  const [listCode, setListCode] = useState<any[]>([]);
  const [loadingListCode, setLoadingListCode] = useState<boolean>(false);

  //Preços
  const [sale, setSale] = useState<string>('0.00');
  const [minSale, setMinSale] = useState<string>('0.00');
  const [coast, setCoast] = useState<string>('0.00');
  const [promotionalPrice, setPromotionalPrice] = useState<string>('0.00');
  const [markupPrice, setMarkupPrice] = useState<string>('');
  const [markup, setMarkup] = useState<string>('');
  //Unidade de medida
  const [unit, setUnit] = useState<number>(0);
  //Informações de estoque
  const [stock_uuid, setStock_uuid] = useState<string>('');

  const [currentAmount, setCurrentAmount] = useState<string>('0');
  const [minAmount, setMinAmount] = useState<string>('0');
  const [localStock, setLocalStock] = useState<number | undefined>(undefined);
  const [localStockName, setLocalStockName] = useState<string>('');
  const [typeOper, setTypeOper] = useState<number | undefined>(undefined);
  const [unitMeasureBuy, setUnitMeasureBuy] = useState<number | undefined>(
    undefined
  );
  const [multiple, setMultiple] = useState<string>('');
  const [observation, setObservation] = useState<string>('');
  //Informações Fiscais
  const [taxProfile, setTaxProfile] = useState<number | undefined>(undefined);
  const [stateOrigin, setStateOrigin] = useState<number | undefined>(undefined);
  const [stateDestiny, setStateDestiny] = useState<number | undefined>(
    undefined
  );
  const [types, setTypes] = useState<number | undefined>(undefined);
  const [origins, setOrigins] = useState<number | undefined>(undefined);
  const [ncm, setNcm] = useState<number | undefined>(undefined);
  const [cest, setCest] = useState<number | undefined>(undefined);
  const [cfop, setCfop] = useState<number | undefined>(undefined);
  const [customer, setCustomer] = useState<number | undefined>(undefined);
  const [icms, setIcms] = useState<number | undefined>(undefined);
  const [ipi, setIpi] = useState<number | undefined>(undefined);
  const [cstReasons, setCstReasons] = useState<number | undefined>(129);
  const [pis, setPis] = useState<number | undefined>(undefined);
  const [cofins, setCofins] = useState<number | undefined>(undefined);
  const [weight, setWeight] = useState<string>('0');
  const [aliquot, setAliquotIcms] = useState<string>('0');
  const [mva, setMva] = useState<string>('0');
  const [reduction, setReduction] = useState<string>('0');
  const [icmsAliquotDeferral, setIcmsAliquotDeferral] = useState<string>('0');
  const [icmsCredit, setIcmsCredit] = useState<string>('0');
  const [aliquotIpi, setAliquotIpi] = useState<string>('0');
  const [aliquotPis, setAliquotPis] = useState<string>('0');
  const [aliquotCofins, setAliquotCofins] = useState<string>('0');
  //Informações de venda
  const [xdRequestQty, setXdRequestQty] = useState<boolean>(false);
  const [xdRequestPriceWhenZero, setXdRequestPriceWhenZero] =
    useState<boolean>(true);
  const [xdBalanceQty, setXdBalanceQty] = useState<boolean>(false);
  const [xdOrderGrouped, setXdOrderGrouped] = useState<boolean>(true);
  const [xdBillGroup, setXdBillGroup] = useState<boolean>(true);
  const [xdAddTips, setXdAddTips] = useState<boolean>(true);
  const [xdExcludeMinimumConsumption, setXdExcludeMinimumConsumption] =
    useState<boolean>(false);
  const [xdBook, setXdBook] = useState<boolean>(false);
  const [selfService, setSelfService] = useState<boolean>(true);
  const [visible_falimix, setVisible_falimix] = useState<boolean>(true);
  const [visible_autoplu, setVisible_autoplu] = useState<boolean>(true);
  const [visible_delivery, setVisible_delivery] = useState<boolean>(true);
  const [visible_xd_orders, setVisible_xd_orders] = useState<boolean>(true);
  const [visible_online, setVisible_online] = useState<boolean>(true);
  const [visible_digital_menu, setVisible_digital_menu] =
    useState<boolean>(true);
  const [xdFollowItem, setXdFollowItem] = useState<boolean>(false);
  const [xdPrinters, setXdPrinters] = useState<string>(
    '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0'
  );

  const [validCode, setValidCode] = useState<boolean>(false);
  const [validDescriptionSale, setValidDescriptionSale] =
    useState<boolean>(false);
  const [validDescriptionPurchase, setValidDescriptionPurchase] =
    useState<boolean>(false);
  const [validDescriptionTouch, setValidDescriptionTouch] =
    useState<boolean>(false);
  const [validCategory, setValidCategory] = useState<boolean>(false);
  const [validProductType, setValidProductType] = useState<boolean>(false);
  const [validSale, setValidSale] = useState<boolean>(false);
  const [validMinSale, setValidMinSale] = useState<boolean>(false);
  const [validCoast, setValidCoast] = useState<boolean>(false);
  const [validUnit, setValidUnit] = useState<boolean>(false);
  const [validNcm, setValidNcm] = useState<boolean>(false);

  const [validCfop, setValidCfop] = useState<boolean>(false);
  const [validIcms, setValidIcms] = useState<boolean>(false);
  const [validAliquot, setValidAliquot] = useState<boolean>(false);
  const [validAliquotIpi, setValidAliquotIpi] = useState<boolean>(false);
  const [validIpi, setValidIpi] = useState<boolean>(false);
  const [validPis, setValidPis] = useState<boolean>(false);
  const [validCofins, setValidCofins] = useState<boolean>(false);
  const [validAliquotPis, setValidAliquotPis] = useState<boolean>(false);
  const [validType, setValidType] = useState<boolean>(false);
  const [validOrigins, setValidOrigins] = useState<boolean>(false);
  const [validqty, setValidqty] = useState<boolean>(false);
  const [validOrigem, setValidOrigem] = useState<boolean>(false);
  const [validcstReasons, setValidcstReasons] = useState<boolean>(false);
  const [validLocalStock, setValidLocalStock] = useState<boolean>(false);
  const [categoriesList, setCategoriesComplement] = useState<Array<any>>([]);
  const [productsList, setProductsComplement] = useState<Array<any>>([]);
  const [associatedComplement, setAssociatedComplement] = useState<Array<any>>(
    []
  );
  const [productsAssociatedComplement, setProductsAssociatedComplement] =
    useState<Array<any>>([]);
  const [taxProfileManuallySelected, setTaxProfileManuallySelected] =
    useState(false);

  const cleanInputs = () => {
    // Dados gerais
    setStatus(true);
    setImage('');
    setIdPdv('');
    setBarcode('');
    setNcm_origin('Nacional');
    setDescriptionSale('');
    setDescriptionPurchase('');
    setDescriptionTouch('');
    setCategory(undefined);
    setVendor(undefined);
    setProductType(1);
    setListCode([]);
    setLoadingListCode(false);

    // Preços
    setSale('0.00');
    setMinSale('0.00');
    setCoast('0.00');
    setPromotionalPrice('0.00');
    setMarkupPrice('');
    setMarkup('');

    // Unidade de medida
    setUnit(0);

    // Estoque
    setStock_uuid('');
    setCurrentAmount('0');
    setMinAmount('0');
    setLocalStock(undefined);
    setLocalStockName('');
    setTypeOper(undefined);
    setUnitMeasureBuy(undefined);
    setMultiple('');
    setObservation('');

    // Informações fiscais
    setTaxProfile(undefined);
    setStateOrigin(undefined);
    setStateDestiny(undefined);
    setTypes(undefined);
    setOrigins(undefined);
    setNcm(undefined);
    setCest(undefined);
    setCfop(undefined);
    setCustomer(undefined);
    setIcms(undefined);
    setIpi(undefined);
    setCstReasons(129);
    setPis(undefined);
    setCofins(undefined);
    setWeight('0');
    setAliquotIcms('0');
    setMva('0');
    setReduction('0');
    setIcmsAliquotDeferral('0');
    setIcmsCredit('0');
    setAliquotIpi('0');
    setAliquotPis('0');
    setAliquotCofins('0');

    // Informações de venda
    setXdRequestQty(false);
    setXdRequestPriceWhenZero(true);
    setXdBalanceQty(false);
    setXdOrderGrouped(true);
    setXdBillGroup(true);
    setXdAddTips(true);
    setXdExcludeMinimumConsumption(false);
    setXdBook(false);
    setSelfService(true);
    setVisible_falimix(true);
    setVisible_autoplu(true);
    setVisible_delivery(true);
    setVisible_xd_orders(true);
    setVisible_online(true);
    setVisible_digital_menu(true);
    setXdFollowItem(false);
    setXdPrinters('0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0');

    // Validações
    setValidCode(false);
    setValidDescriptionSale(false);
    setValidDescriptionPurchase(false);
    setValidDescriptionTouch(false);
    setValidCategory(false);
    setValidProductType(false);
    setValidSale(false);
    setValidMinSale(false);
    setValidCoast(false);
    setValidUnit(false);
    setValidNcm(false);
    setValidCfop(false);
    setValidIcms(false);
    setValidAliquot(false);
    setValidAliquotIpi(false);
    setValidIpi(false);
    setValidPis(false);
    setValidCofins(false);
    setValidAliquotPis(false);
    setValidType(false);
    setValidOrigins(false);
    setValidqty(false);
    setValidOrigem(false);
    setValidcstReasons(false);
    setValidLocalStock(false);

    // Complementos
    setCategoriesComplement([]);
    setProductsComplement([]);
    setAssociatedComplement([]);
    setProductsAssociatedComplement([]);

    // Outros
    setTaxProfileManuallySelected(false);
  };

  const handleEdit = async (props: IProduct) => {
    const products = props;

    setNcm_origin(products?.ncm_origin);
    setStatus(products?.is_active);
    setImage(products?.image);
    setIdPdv(products?.id_pdv?.toString());
    setBarcode(products?.barcode ?? '');
    setDescriptionSale(products?.sale_name);
    setDescriptionPurchase(products?.purchase_name);
    setDescriptionTouch(products?.touch_name);
    setCategory(products?.id_pdv_category);
    setVendor(products?.vendor_id);
    setProductType(products?.product_type_id);
    setSale(products?.sale_price?.toString() ?? '0');
    setMinSale(products?.sale_minimal_price?.toString() ?? '0');
    setCoast(products?.cost_price?.toString() ?? '0');
    setPromotionalPrice(products?.promotional_price?.toString() ?? '0');
    setMarkupPrice(products?.markup_value?.toFixed(2)?.toString() ?? '0');
    setMarkup(products?.markup_percentil?.toFixed(2)?.toString() ?? '0');
    //setStock_uuid()

    setUnit(products?.sale_measure_unit_id);
    setMinAmount(products?.stock_minimal_qty?.toString() ?? '0');
    setCurrentAmount(products?.stock_qty?.toString() ?? '0');
    setLocalStock(products?.stock_local_id === 1 ? 0 : products?.stock_local_id);
    //setLocalStock(products?.stock_reference);
    setTypeOper(products?.product_purpose_id);
    setUnitMeasureBuy(products?.stock_measure_unit_id);
    setMultiple(products?.sale_measure_unit_multiplier?.toString() ?? '0');
    setObservation(products?.stock_reference);
    setTaxProfile(products?.tax_profile_id);
    setStateOrigin(products?.icms_origin_state_id);
    setStateDestiny(products?.icms_destiny_state_id);
    setTypes(products?.tax_invoice_type_id);
    setOrigins(products?.cst_origin_id);
    setNcm(products?.ncm_id);
    setCest(products?.cest_id);
    setCfop(products?.cfop_id);
    setCustomer(products?.icms_customer_type_id);
    setIcms(products?.cst_icms_id);
    setIpi(products?.cst_ipi_id);
    setCstReasons(products?.cst_ipi_reason_id ?? 129);
    setPis(products?.cst_pis_id);
    setCofins(products?.cst_cofins_id);
    setWeight(products?.tax_weight?.toString() ?? '0');
    setAliquotIcms(products?.icms_aliquot?.toString() ?? '0');
    setMva(products?.icms_mva?.toString() ?? '0');
    setReduction(products?.icms_base_calc_reduction?.toString() ?? '0');
    setIcmsAliquotDeferral(products?.icms_aliquot_deferral?.toString() ?? '0');
    setIcmsCredit(products?.icms_credit?.toString() ?? '0');
    setAliquotIpi(products?.ipi_aliquot?.toString() ?? '0');
    setAliquotPis(products?.pis_aliquot?.toString() ?? '0');
    setAliquotCofins(products?.cofins_aliquot?.toString() ?? '0');
    setXdRequestQty(products?.xd_request_qty);
    setXdRequestPriceWhenZero(products?.xd_request_price_when_zero);
    setXdBalanceQty(products?.xd_balance_qty);
    setXdOrderGrouped(products?.xd_order_grouped);
    setXdBillGroup(products?.xd_bill_group);
    setXdAddTips(products?.xd_add_tips);
    setXdExcludeMinimumConsumption(products?.xd_exclude_minimum_consumption);
    setXdBook(products?.xd_book);
    setXdFollowItem(products?.xd_follow_item);
    setXdPrinters(products?.xd_printers);
    setNcm(products?.ncm_id);
    setSelfService(products?.self_service);
    setVisible_falimix(products?.visible_falimix);
    setVisible_autoplu(products?.visible_autoplu);
    setVisible_delivery(products?.visible_delivery);
    setVisible_xd_orders(products?.visible_xd_orders);
    setVisible_online(products?.visible_online);
    setVisible_digital_menu(products?.visible_digital_menu);
    setCategoriesComplement(products?.relationships.complements);
    setAssociatedComplement(products?.relationships.associateds);
  };

  const handleDuplicate = async (props: IProduct) => {
    const products = props;
    setStatus(products?.is_active);
    setImage('');

    setBarcode('');
    setDescriptionSale('');
    setDescriptionPurchase('');
    setDescriptionTouch('');
    setCategory(products?.id_pdv_category);
    setVendor(products?.vendor_id);
    setProductType(products?.product_type_id);
    setSale(products?.sale_price?.toString() ?? '0');
    setMinSale(products?.sale_minimal_price?.toString() ?? '0');
    setCoast(products?.cost_price?.toString() ?? '0');
    setPromotionalPrice(products?.promotional_price?.toString() ?? '0');
    setMarkupPrice(products?.markup_value?.toString() ?? '0');
    setMarkup(products?.markup_percentil?.toString() ?? '0');
    setUnit(products?.sale_measure_unit_id);
    setCurrentAmount('0');
    setMinAmount('0');
    setLocalStock(products?.stock_local_id === 1 ? 0 : products?.stock_local_id);
    setTypeOper(products?.product_purpose_id);
    setUnitMeasureBuy(products?.stock_measure_unit_id);
    setMultiple('');
    setNcm_origin('');
    //setObservation(products?.stock_reference);
    setTaxProfile(products?.tax_profile_id);
    setStateOrigin(products?.icms_origin_state_id);
    setStateDestiny(products?.icms_destiny_state_id);
    setTypes(products?.tax_invoice_type_id);
    setOrigins(products?.cst_origin_id);
    setCest(products?.cest_id);
    setCfop(products?.cfop_id);
    setCustomer(products?.icms_customer_type_id);
    setIcms(products?.cst_icms_id);
    setIpi(products?.cst_ipi_id);
    setCstReasons(products?.cst_ipi_reason_id ?? 129);
    setPis(products?.cst_pis_id);
    setCofins(products?.cst_cofins_id);
    setWeight(products?.tax_weight?.toString() ?? '0');
    setAliquotIcms(products?.icms_aliquot?.toString() ?? '0');
    setMva(products?.icms_mva?.toString() ?? '0');
    setReduction(products?.icms_base_calc_reduction?.toString() ?? '0');
    setIcmsAliquotDeferral(products?.icms_aliquot_deferral?.toString() ?? '0');
    setIcmsCredit(products?.icms_credit?.toString() ?? '0');
    setAliquotIpi(products?.ipi_aliquot?.toString() ?? '0');
    setAliquotPis(products?.pis_aliquot?.toString() ?? '0');
    setAliquotCofins(products?.cofins_aliquot?.toString() ?? '0');
    setXdRequestQty(products?.xd_request_qty);
    setXdRequestPriceWhenZero(products?.xd_request_price_when_zero);
    setXdBalanceQty(products?.xd_balance_qty);
    setXdOrderGrouped(products?.xd_order_grouped);
    setXdBillGroup(products?.xd_bill_group);
    setXdAddTips(products?.xd_add_tips);
    setXdExcludeMinimumConsumption(products?.xd_exclude_minimum_consumption);
    setXdBook(products?.xd_book);
    setXdFollowItem(products?.xd_follow_item);
    setXdPrinters(products?.xd_printers);
    setNcm(products?.ncm_id);
    setSelfService(products?.self_service);
    setVisible_falimix(products?.visible_falimix);
    setVisible_autoplu(products?.visible_autoplu);
    setVisible_delivery(products?.visible_delivery);
    setVisible_xd_orders(products?.visible_xd_orders);
    setVisible_online(products?.visible_online);
    setVisible_digital_menu(products?.visible_digital_menu);
    setCategoriesComplement(products?.relationships.complements);
    setAssociatedComplement(products?.relationships.associateds);
  };

  const handleValidete = () => {
    if (!idPdv) setValidCode(true);
    if (idPdv) setValidCode(false);
    if (!descriptionSale) setValidDescriptionSale(true);
    if (descriptionSale) setValidDescriptionSale(false);
    if (!descriptionPurchase) setValidDescriptionPurchase(true);
    if (descriptionPurchase) setValidDescriptionPurchase(false);
    if (!descriptionTouch) setValidDescriptionTouch(true);
    if (descriptionTouch) setValidDescriptionTouch(false);
    if (!category) setValidCategory(true);
    if (category) setValidCategory(false);

    if (!sale) setValidSale(true);
    if (sale) setValidSale(false);
    if (!minSale) setValidMinSale(true);
    if (minSale) setValidMinSale(false);
    if (!coast) setValidCoast(true);
    if (coast) setValidCoast(false);
    if (!unit) setValidUnit(true);
    if (unit) setValidUnit(false);
    if (!ncm) setValidNcm(true);
    if (ncm) setValidNcm(false);
    //if (selfService && !cest) setValidCest(true);
    //if (selfService && cest) setValidCest(false);
    if (selfService && !cstReasons) setValidcstReasons(true);
    if (selfService && cstReasons) setValidcstReasons(false);

    if (!cfop) setValidCfop(true);
    if (cfop) setValidCfop(false);
    if (!icms) setValidIcms(true);
    if (icms) setValidIcms(false);
    if (!aliquot) setValidAliquot(true);
    if (aliquot) setValidAliquot(false);
    if (!ipi) setValidIpi(true);
    if (ipi) setValidIpi(false);
    if (!aliquotIpi) setValidAliquotIpi(true);
    if (aliquotIpi) setValidAliquotIpi(false);
    if (!pis) setValidPis(true);
    if (pis) setValidPis(false);
    if (!cofins) setValidCofins(true);
    if (cofins) setValidCofins(false);
    if (!aliquotPis) setValidAliquotPis(true);
    if (aliquotPis) setValidAliquotPis(false);

    if (!currentAmount) setValidqty(true);
    if (currentAmount || typeOper === 1) setValidqty(false);
    if (!localStock) setValidLocalStock(true);
    if (localStock || typeOper === 1) setValidLocalStock(false);

    if (
      idPdv &&
      descriptionSale &&
      category &&
      (productType || productType === 0) &&
      sale &&
      minSale &&
      coast &&
      unit &&
      ncm &&
      (selfService ? cstReasons : true) &&
      cfop &&
      icms &&
      aliquot &&
      ipi &&
      aliquotIpi &&
      pis &&
      cofins &&
      aliquotPis &&
      (currentAmount || typeOper === 1) &&
      (localStock || typeOper === 1)
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (idPdv) setValidCode(false);
    if (descriptionSale) setValidDescriptionSale(false);
    if (descriptionPurchase) setValidDescriptionPurchase(false);
    if (descriptionTouch) setValidDescriptionTouch(false);
    if (category) setValidCategory(false);

    if (sale) setValidSale(false);
    if (minSale) setValidMinSale(false);
    if (coast) setValidCoast(false);
    if (unit) setValidUnit(false);
    if (ncm) setValidNcm(false);

    if (cfop) setValidCfop(false);
    if (icms) setValidIcms(false);
    if (aliquot) setValidAliquot(false);
    if (ipi) setValidIpi(false);
    if (aliquotIpi) setValidAliquotIpi(false);
    if (pis) setValidPis(false);
    if (cofins) setValidCofins(false);
    if (aliquotPis) setValidAliquotPis(false);

    if (currentAmount) setValidqty(false);
    if (localStock) setValidLocalStock(false);
  }, [
    idPdv,
    descriptionSale,
    descriptionPurchase,
    descriptionTouch,
    category,
    sale,
    minSale,

    selfService,
    coast,
    unit,
    ncm,
    cfop,
    icms,
    aliquot,
    aliquotIpi,
    pis,
    cofins,
    aliquotPis,

    ipi,
    currentAmount,
    localStock,
  ]);

  return (
    <ProdutoContext.Provider
      value={{
        loading,
        setLoading,
        status,
        setStatus,
        idPdv,
        setIdPdv,
        image,
        setImage,
        barcode,
        setBarcode,
        descriptionSale,
        setDescriptionSale,
        descriptionPurchase,
        setDescriptionPurchase,
        descriptionTouch,
        setDescriptionTouch,
        category,
        setCategory,
        vendor,
        setVendor,
        productType,
        setProductType,
        sale,
        setSale,
        minSale,
        setMinSale,
        coast,
        setCoast,
        promotionalPrice,
        setPromotionalPrice,
        markupPrice,
        setMarkupPrice,
        markup,
        setMarkup,

        stock_uuid,
        setStock_uuid,
        unit,
        setUnit,
        currentAmount,
        setCurrentAmount,
        minAmount,
        setMinAmount,
        localStock,
        setLocalStock,
        observation,
        setObservation,
        typeOper,
        setTypeOper,
        multiple,
        setMultiple,
        unitMeasureBuy,
        setUnitMeasureBuy,
        taxProfile,
        setTaxProfile,
        stateOrigin,
        setStateOrigin,
        stateDestiny,
        setStateDestiny,
        types,
        setTypes,
        origins,
        setOrigins,
        ncm,
        setNcm,
        cest,
        setCest,
        cfop,
        setCfop,
        customer,
        setCustomer,
        icms,
        setIcms,
        ipi,
        setIpi,
        cstReasons,
        setCstReasons,
        pis,
        setPis,
        weight,
        setWeight,
        aliquot,
        setAliquotIcms,
        mva,
        setMva,
        reduction,
        setReduction,
        icmsAliquotDeferral,
        setIcmsAliquotDeferral,
        icmsCredit,
        setIcmsCredit,
        aliquotIpi,
        setAliquotIpi,
        aliquotPis,
        setAliquotPis,
        aliquotCofins,
        setAliquotCofins,
        xdRequestQty,
        setXdRequestQty,
        xdRequestPriceWhenZero,
        setXdRequestPriceWhenZero,
        xdBalanceQty,
        setXdBalanceQty,
        xdOrderGrouped,
        setXdOrderGrouped,
        xdBillGroup,
        setXdBillGroup,
        xdAddTips,
        setXdAddTips,
        xdExcludeMinimumConsumption,
        setXdExcludeMinimumConsumption,
        xdBook,
        setXdBook,
        selfService,
        setSelfService,
        xdFollowItem,
        setXdFollowItem,
        xdPrinters,
        setXdPrinters,
        cleanInputs,
        handleEdit,
        handleDuplicate,
        handleValidete,
        validCode,
        setValidCode,
        validDescriptionSale,
        setValidDescriptionSale,
        validDescriptionPurchase,
        setValidDescriptionPurchase,
        validDescriptionTouch,
        setValidDescriptionTouch,
        validCategory,
        setValidCategory,
        validProductType,
        setValidProductType,
        validSale,
        setValidSale,
        validMinSale,
        setValidMinSale,
        validCoast,
        setValidCoast,
        validUnit,
        setValidUnit,
        validNcm,
        setValidNcm,
        validCfop,
        setValidCfop,
        validIcms,
        setValidIcms,
        validAliquot,
        setValidAliquot,
        validAliquotIpi,
        setValidAliquotIpi,
        validIpi,
        setValidIpi,
        validPis,
        setValidPis,
        validAliquotPis,
        setValidAliquotPis,
        validType,
        setValidType,
        validOrigins,
        setValidOrigins,
        validqty,
        setValidqty,
        validLocalStock,
        setValidLocalStock,
        listCode,
        setListCode,
        localStockName,
        setLocalStockName,
        setCofins,
        setValidCofins,
        cofins,
        validCofins,
        loadingListCode,
        setLoadingListCode,
        categoriesList,
        setCategoriesComplement,

        validcstReasons,
        setValidcstReasons,
        validOrigem,
        setValidOrigem,
        productsList,
        setProductsComplement,
        associatedComplement,
        setAssociatedComplement,
        productsAssociatedComplement,
        setProductsAssociatedComplement,
        ncm_origin,
        setNcm_origin,
        visible_falimix,
        setVisible_falimix,
        visible_autoplu,
        setVisible_autoplu,
        visible_delivery,
        setVisible_delivery,
        visible_xd_orders,
        setVisible_xd_orders,
        visible_online,
        setVisible_online,
        visible_digital_menu,
        setVisible_digital_menu,
        taxProfileManuallySelected,
        setTaxProfileManuallySelected,
      }}
    >
      {children}
    </ProdutoContext.Provider>
  );
};
